module.exports = __webpack_public_path__ + "static/media/02_workshop_video.6ee5d910.png";